<nav aria-label="adc-breadcrumb" *ngIf="type == 'style1'" ngClass="{{ data.customClass }}">
    <ol class="adc-breadcrumb">
      <li *ngFor="let i of data.items" (click)="link.emit(i)">{{i.label | translate}} <span class="adc-ml20 adc-d-flex adc-align-items-center" *ngIf="i !== data.items[data.items.length - 1];">/</span></li>
      <!-- <li>/</li>
      <li>Component</li>
      <li>/</li>
      <li>Data</li> -->
    </ol>
</nav>
<nav *ngIf="type == 'style1Icon'" ngClass="{{ data.customClass }}">
    <ol class="adc-breadcrumb">
      <li *ngFor="let i of data.items" (click)="link.emit(i)">
        <!-- <mat-icon class="adc-fs-20" style="line-height: 1.2;">{{i.icon}}</mat-icon> -->
        <img [src]="i.icon" style="line-height: 1.2;" alt="" width="20px" height="20px">
        <span>{{i.label | translate}}</span><span class="adc-ml10 adc-d-flex adc-align-items-center" *ngIf="i !== data.items[data.items.length - 1];">/</span></li>
      <!-- <li>/</li>
      <li><mat-icon class="adc-fs-15 adc-pl5" style="line-height: 1.2;">settings_input_component</mat-icon><span>Component</span></li>
      <li>/</li>
      <li><mat-icon class="adc-fs-18 adc-pl5" style="line-height: 1.2;"> cloud_queue </mat-icon><span>Data</span></li> -->
    </ol>
</nav>

<nav class="adc-position-relative" *ngIf="type == 'style2'" ngClass="{{ data.customClass }}">
    
    <ul class="adc-breadcrumb4">
        <li *ngFor="let i of data.items"><a (click)="link.emit(i)">{{i.label | translate}}</a></li>
        <!-- <li><a>Component</a></li>
        <li>
            <a (click)="toggleActive()">...</a>
        </li>
        <li><a>Data</a></li> -->
    </ul>
</nav>
<nav *ngIf="type == 'style2Icon'" ngClass="{{ data.customClass }}">
    <ul class="adc-breadcrumb4">
        <li *ngFor="let i of data.items"><a (click)="link.emit(i)"><span>{{i.label | translate}}</span> 
            <img [src]="i.icon" class="adc-mr-5 adc-ml5" style="transform: translateY(7px);" alt="" width="20px" height="20px">
            <!-- <mat-icon class="adc-fs-20 adc-mr-5 adc-ml5" style="transform: translateY(7px);">{{i.icon}}</mat-icon> -->

        </a></li>
        <!-- <li><a><span>Component</span> <mat-icon class="adc-fs-15 adc-pl5 adc-mr-10 adc-ml5" style="transform: translateY(10px);">settings_input_component</mat-icon></a></li>
        <li><a><span>Data</span> <mat-icon class="adc-fs-18 adc-pl5 adc-mr-5 adc-ml5" style="transform: translateY(9px);"> cloud_queue </mat-icon></a></li> -->
    </ul>
</nav>
